import BaseSportPage from '../components/shared/BaseSportPage';
export default function AmericanFootball() {
  return <BaseSportPage sport="american-football" label="American Football" />;
}
